module.exports = __webpack_public_path__ + "static/media/faviconCruz.b0bc9583.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/faviconCruz.png
// module id = 1603
// module chunks = 0